(function() {
    angular
        .module("app")
        .factory("devicesService", devicesService)

    devicesService.$inject = [
        "$rootScope",
        "$http",
        "queryStringService"
    ]

    function devicesService(
        $rootScope,
        $http,
        queryStringService
    ) {
        var service = {}
        var totalDevices = {}
        var deviceSortOptions = [
            "name",
            "alerts",
            "id",
            "health",
            "refreshed",
            "model_number"
        ]

        var categorizeDevices = function(devices) {
            var categorized = {
                all:                [],
                messageBoards:      [],
                speedLimitTrailers: [],
                trackers:           [],
                arrowBoards:        [],
                trucksEnter:        []
            }

            for (const device of devices) {

                if (device !== null && device !== undefined && device.hasOwnProperty("device")) {

                    $rootScope.processDevice(device)
                    categorized.all.push(device)

                    if (device.meta.isMessageBoard)                  { categorized.messageBoards.push(device) }
                    if (device.meta.isMessageBoardSpeedLimitTrailer) { categorized.speedLimitTrailers.push(device) }
                    if (device.meta.isTracker)                       { categorized.trackers.push(device) }
                    if (device.meta.isTrackerArrowBoard)             { categorized.arrowBoards.push(device) }
                    if (device.meta.isTrackerTrucksEnter)            { categorized.trucksEnter.push(device) }
                }
            }

            return categorized

        }

        /**
            Get all devices
            @param {func?} successCallback
            @param {func?} failureCallback
         **/
        service.getDevices = function(successCallback, failureCallback) {

            var extractCustomerID = queryStringService.extractCustomerID($rootScope.selectedCustomerID)

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/devices/?" + extractCustomerID
                    + "&perpage=" + 500
            }).then(success, failure)

            function success(response) {
                totalDevices = response.headers("Total")
                if (successCallback !== undefined) {
                    successCallback(categorizeDevices(response.data))
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.getDeviceSummaries = function(successCallback, failureCallback) {

            var extractCustomerID = queryStringService.extractCustomerID($rootScope.selectedCustomerID)

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/devices/?as_summaries=true&" + extractCustomerID
                    + "&perpage=" + 500
            }).then(success, failure)

            // $http({
            //     method: "GET",
            //     url: $rootScope.config.apiUrl + "/devices/summaries?" + extractCustomerID
            // }).then(success, failure)

            function success(response) {
                totalDevices = response.headers("Total")
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.getDevicesSorted = (sortBy, sortDirection, deviceGroupIDs, searchData, deviceIDs, page, perPage, successCallback, failureCallback) => {

            let extractCustomerID = queryStringService.extractCustomerID($rootScope.selectedCustomerID)
            const parseDeviceIDs = service.parseDevices(deviceIDs)

            if ($rootScope.selectedZZCabID !== undefined) {
                extractCustomerID = queryStringService.extractCustomerID($rootScope.selectedZZCabID)
            }

            if (deviceSortOptions.indexOf(sortBy) < 0) {
                sortBy = "name"
            }

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/devices?"
                + parseDeviceIDs
                + "sort=" + sortBy
                + "&sort_direction=" + sortDirection
                + "&" + service.parseDeviceGroups(deviceGroupIDs)
                + "&search=" + searchData
                + "&page=" + page
                + "&perpage=" + perPage
                + extractCustomerID
            }).then(success, failure)

            function success(response) {
                totalDevices = response.headers("Total")
                if (successCallback !== undefined) {
                    successCallback(categorizeDevices(response.data))
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.getDeployedArrowBoards = (successCallback, failureCallback) => {

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/devices/deployed_arrow_boards"

            }).then(success, failure)

            function success(response) {
                totalDevices = response.headers("Total")
                if (successCallback !== undefined) {
                    successCallback(categorizeDevices(response.data))
                }
            }

            function failure(error) {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.moveDevices = function(deviceIDs, customerID, successCallback, failureCallback) {

            $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/devices/move_to_customer",
                data: {
                    ids: deviceIDs,
                    target_customer_id: customerID
                }
            }).then(success, failure)

            function success(response) {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
            }

            function failure(error) {
                console.error("Move Devices Failure:", error.data)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
            }
        }

        service.setActiveUseInWZ = (deviceID, activate, successCallback, failureCallback) => {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/devices/" + deviceID + "/active_use_in_wz",
                data: {
                    active_use_in_wz: activate
                }
            }).then(success, failure)
        }

        service.setDisableDOTAccess = (deviceID, disable, successCallback, failureCallback) => {

            const success = (response) => {
                if (successCallback !== undefined) {
                    successCallback(response.data)
                }
                return response.data
            }

            const failure = (error) => {
                console.error(error)
                if (failureCallback !== undefined) {
                    failureCallback(error)
                }
                return error
            }

            return $http({
                method: "PUT",
                url: $rootScope.config.apiUrl + "/devices/" + deviceID + "/disable_dot_access",
                data: {
                    disable_dot_access: disable
                }
            }).then(success, failure)
        }

        /**
            Get devices count
            @returns {*}
         **/
        service.getTotalDevices = function() {
            return totalDevices
        }

        /**
            Parse devices
            @param deviceIDs
            @returns {string}
         **/
        service.parseDevices = function(deviceIDs) {

            let query = ""

            if (deviceIDs) {

                for (const deviceID of deviceIDs) {
                    if (deviceID) {
                        query += "device_ids[]=" + deviceID + "&"
                    }
                }
            }

            return query
        }

        /**
            Parse device groups
            @param groupIDs
            @returns {string}
         **/
        service.parseDeviceGroups = function(groupIDs) {

            let query = ""

            if (groupIDs) {

                for (const deviceGroupID of Object.keys(groupIDs)) {
                    if (groupIDs[deviceGroupID]) {
                        query += "device_group_ids[]=" + deviceGroupID + "&"
                    }
                }
            }

            return query
        }

        service.searchDevices = function(searchData, page, perPage, minimumTimeMs, successCallback, failureCallback) {

            const start = new Date().getTime()

            $http({
                method: "GET",
                url: $rootScope.config.apiUrl + "/devices/search?"
                + "search=" + searchData
                + "&page=" + page
                + "&perpage=" + perPage
            }).then(success, failure)

            function success(response) {
                setTimeout(() => {
                    if (successCallback !== undefined) {
                        successCallback(response.data, response.headers("Total"))
                    }
                }, Math.min(0, minimumTimeMs - (new Date().getTime() - start)))
            }

            function failure(error) {
                setTimeout(() => {
                    console.error(error)
                    if (failureCallback !== undefined) {
                        failureCallback(error)
                    }
                }, Math.min(0, minimumTimeMs - (new Date().getTime() - start)))
            }
        }

        return service

    }
})()
